import dayjs from "dayjs";

/* ---------- shared helpers ---------- */
const shortDate = (v) => (v ? dayjs(v).format("YYYY-MM-DD") : "");

const formatDateTimeForMySQL = (isoString) => {
  if (!isoString) return null;
  const d = new Date(isoString);
  const pad = (n) => (n < 10 ? '0' + n : n);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};


export const buildTransferPayload = (d, quotationId) => {
  const required_fields = [
    "full_name_as_per_passport",
    "pickup_location",
    "dropoff_location",
    "pickup_datetime"
  ];

  const errors = {};

  if (!d || !d.declaration_agreed) {
    errors["declaration_agreed"] = "Please agree to the Terms and Conditions.";
  }

  // ✅ Signature is required: allow if either new or old is present
  const hasOldSignature = d?.digital_or_physical_signature;
  const hasNewSignature = d?.new_digital_or_physical_signature;

  if (!hasNewSignature && !hasOldSignature) {
    errors["digital_or_physical_signature"] = "Please add signature.";
  }

  // ✅ Prevent crash if `d` is undefined or null
  if (!d || typeof d !== "object") {
    required_fields.forEach((field) => {
      errors[field] = "This field is required.";
    });
    return { errors };
  }

  required_fields.forEach((field) => {
    if (!d[field]) {
      errors[field] = "This field is required.";
    }
  });

  if (Object.keys(errors).length > 0) {
    return { errors };
  }

  return {
        payload: {
            quotation_id: quotationId,
            name: d?.name,
            full_name_as_per_passport: d?.full_name_as_per_passport,
            date_of_birth: d?.date_of_birth ? shortDate(d?.date_of_birth) : null,
            nationality: d?.nationality?.name,
            contact_number: d?.contact_number,
            pickup_location: d?.pickup_location,
            dropoff_location: d?.dropoff_location,
            pickup_datetime: d?.pickup_datetime ? formatDateTimeForMySQL(d?.pickup_datetime) : null,
            transfer_type: d?.transfer_type,
            preferred_vehicle_type: d?.preferred_vehicle_type,
            number_of_passengers: d?.number_of_passengers,
            special_requests: d?.special_requests,
            payment_method: d?.payment_method,
            billing_address: d?.billing_address,
            invoice_required: d?.invoice_required,
            flight_details: d?.flight_details,
            hotel_details: d?.hotel_details,
            contact_at_destination: d?.contact_at_destination,
            declaration_agreed: d?.declaration_agreed,
            digital_or_physical_signature: hasNewSignature ? hasNewSignature : hasOldSignature
        }
    };
};

export default buildTransferPayload;
